import React from 'react';
import { Header } from 'react-aria-components';

type Props = {
  children: React.ReactNode;
};
export const MenuHeader = ({ children }: Props) => {
  return <Header>{children}</Header>;
};
